document.addEventListener('DOMContentLoaded', function () {
    const buttons = document.querySelectorAll('.filter_button');

    buttons.forEach((button) => {
        button.addEventListener('click', function () {
            const filterparam = 'filter.p.m.custom.product_filter';
            let param = new URLSearchParams(window.location.search);
            let currentFilter = param.getAll(filterparam);
            let filterValue = this.dataset.filter;

            if (currentFilter.includes(filterValue)) {
                
                currentFilter = currentFilter.filter(value => value !== filterValue);
            } else {
                
                currentFilter.push(filterValue);
            }

          
            param.delete(filterparam);

            
            currentFilter.forEach(value => param.append(filterparam, value));

           
            const newUrl = `${window.location.origin}${window.location.pathname}?${param.toString()}`;

            
            window.history.pushState({}, '', newUrl);

           
            this.classList.toggle('active');

            FacetFiltersForm.renderPage(param.toString());
        });

        
        let param = new URLSearchParams(window.location.search);
        if (param.getAll('filter.p.m.custom.product_filter').includes(button.dataset.filter)) {
            button.classList.add('active');
        }
    });
});
